import { TreeProgramTopHeader } from 'components/common';
import { excellenceAppsConfig } from 'components/Dashboards/ExcellenceApps/excellenceAppsConfig';
import PageContainer from 'components/common/PageContainer/PageContainer';
import { ShareInsightButton } from 'components/common/ShareInsightButton/ShareInsightButton';
import { LogicQualityCheckActionsMenu } from 'components/widgets/LogicQualityCheckActionsMenu/LogicQualityCheckActionsMenu';
import { MainContent } from 'components/common/PageContainer/MainContent';
import { useFullStoryPageView } from 'hooks/useFullstoryPageView';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { SummaryWrapper } from 'components/widgets/SummaryWrapper/summaryWrapper';
import { MilestoneFragnetFilter } from 'components/common/GlobalFilterComponent/components/MilestoneFragnetFilter/MilestoneFragnetFilter';
import { TagsFilter } from 'components/common/GlobalFilterComponent/components/TagsFilter/TagsFilter';
import { ActivityCodesFilter } from 'components/common/GlobalFilterComponent/components/ActivityCodesFilter/ActivityCodesFilter';
import { GlobalFilterComponent } from 'components/common/GlobalFilterComponent/GlobalFilterComponent';
import { GlobalFilterButton } from 'components/common/GlobalFilterButton/GlobalFilterButton';
import { WbsFilter } from 'components/common/GlobalFilterComponent/components/WbsFilter/wbsFilter';
import { useLogicCheckerBreadCrumbs } from 'hooks/useLogicCheckerBreadCrumbs';
import { Breadcrumbs } from 'components/common/Breadcrumbs/Breadcrumbs';

export const LogicQualityCheckSummaryPage = () => {
    useFullStoryPageView({ pageName: excellenceAppsConfig.logicQualityCheck.title });
    const { breadcrumbs } = useLogicCheckerBreadCrumbs({ displayLevel3Activities: false });

    return (
        <PageContainer>
            <HeaderWrapper>
                <TreeProgramTopHeader pageTitle={excellenceAppsConfig.logicQualityCheck.title}>
                    <ShareInsightButton
                        title={excellenceAppsConfig.logicQualityCheck.title}
                        link={window.location.href}
                    />
                    <LogicQualityCheckActionsMenu />
                    <GlobalFilterButton />
                </TreeProgramTopHeader>
                <GlobalFilterComponent
                    defaultValues={{ milestoneFragnet: null, tags: [], activityCodes: [], wbs: null }}
                >
                    <MilestoneFragnetFilter name={'milestoneFragnet'} />
                    <TagsFilter name={'tags'} />
                    <ActivityCodesFilter name={'activityCodes'} />
                    <WbsFilter name={'wbs'} />
                </GlobalFilterComponent>
                <Breadcrumbs list={breadcrumbs} />
            </HeaderWrapper>
            <MainContent>
                <SummaryWrapper />
            </MainContent>
        </PageContainer>
    );
};
